import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import PRODUCTS from "./util/mock-products"; // or wherever your data file is

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SearchResults() {
  const query = useQuery().get("query")?.toLowerCase().trim() || "";
  console.log('query: ' + query);

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      const filtered = PRODUCTS.filter(
        (p) =>
          p.title.toLowerCase().includes(query) ||
          p.brand?.toLowerCase().includes(query)
      );
      setResults(filtered);
      setLoading(false);
      window.scrollTo(0, 0);
    }, 150);

    return () => clearTimeout(timer);
  }, [query]);

  return (
    <main style={{ width: "min(1100px, 94%)", margin: "28px auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h1 style={{ margin: 0 }}>Search Results</h1>
        <div style={{ color: "#6b7280" }}>
          <Link to="/">Home</Link> / <strong>Search</strong>
        </div>
      </div>

      <p style={{ color: "#6b7280", marginTop: 8 }}>
        Showing results for “{query}”.
      </p>

      {loading ? (
        <div style={{ padding: 40 }}>Loading…</div>
      ) : results.length === 0 ? (
        <div
          style={{
            padding: "60px 20px",
            textAlign: "center",
            color: "#6b7280",
          }}
        >
          <h2 style={{ margin: "8px 0", color: "#111827" }}>No results found</h2>
          <p style={{ margin: 0 }}>
            We couldn’t find any products matching “{query}”.
          </p>
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))",
            gap: 16,
            marginTop: 16,
          }}
        >
          {results.map((p) => {
            const firstVariant = p.variants?.[0];
            const price = firstVariant ? firstVariant.price : null;

            return (
              <article
                key={p.id}
                style={{
                  border: "1px solid #eee",
                  borderRadius: 12,
                  overflow: "hidden",
                  background: "white",
                }}
              >
                <Link
                  to={`/product/${p.id}`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    display: "block",
                  }}
                >
                  <div
                    style={{
                      height: 160,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#fbfbfd",
                    }}
                  >
                    {p.images?.length ? (
                      <img
                        src={p.images[0]}
                        alt={p.title}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <div style={{ color: "#9ca3af" }}>No image</div>
                    )}
                  </div>

                  <div style={{ padding: 12 }}>
                    <div style={{ fontWeight: 700 }}>{p.title}</div>
                    <div style={{ color: "#6b7280", marginTop: 6 }}>
                      {p.brand}
                    </div>
                    <div
                      style={{
                        marginTop: 8,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ fontWeight: 800 }}>
                        {price ? `$${price.toFixed(2)}` : "—"}
                      </div>
                      <div>
                        <button
                          style={{
                            border: "none",
                            background: "#0ea5e9",
                            color: "white",
                            padding: "8px 10px",
                            borderRadius: 8,
                            cursor: "pointer",
                          }}
                        >
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                </Link>
              </article>
            );
          })}
        </div>
      )}
    </main>
  );
}
